import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import ProviderName from "ai-management/components/ProviderName";
const DeleteConsequence = ({ provider, providers, fallback = null }) => {
  const { t } = useTranslation("enterprise_ai");
  const name = /* @__PURE__ */ React.createElement(ProviderName, { providerId: provider.provider });
  if (provider.is_default) {
    const hasOtherProviders = providers.some(({ id }) => id !== provider.id);
    return hasOtherProviders ? /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "delete_consequence.default_with_others", components: { providerName: name } })) : /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "delete_consequence.default_only", components: { providerName: name } }));
  }
  if (provider.used_by_features > 0) {
    const defaultProvider = providers.find(({ is_default }) => is_default);
    if (!defaultProvider) {
      return /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
        Trans,
        {
          t,
          i18nKey: "delete_consequence.used_without_default",
          count: provider.used_by_features,
          components: { providerName: name }
        }
      ));
    }
    return /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "delete_consequence.used_with_default",
        count: provider.used_by_features,
        components: {
          providerName: name,
          defaultProviderName: /* @__PURE__ */ React.createElement(ProviderName, { providerId: defaultProvider.provider })
        }
      }
    ));
  }
  return fallback;
};
export default DeleteConsequence;
